import { render } from "./ChatButton.vue?vue&type=template&id=70deb83e"
import script from "./ChatButton.vue?vue&type=script&lang=js"
export * from "./ChatButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__